import CreatedAuthentication from './CreatedAuthentication';

export default CreatedAuthentication;
